import React from "react";
import { ElaborationMessage } from "../../redux/feature/object/remote-elaborations-slice";
import { Checkbox, CheckboxChangeEvent } from "@progress/kendo-react-inputs";
import { MessageElaborationCard } from "./MessageDetailsModal";

export interface MessageDetailsCardProps {
  message: MessageElaborationCard;
  selected?: boolean;
  index: number;
  onCheck: (item: ElaborationMessage, selected: boolean) => void;
}

const checkboxStyles = {
  marginRight: "5px",
};

const cardStyles: React.CSSProperties = {
  display: "flex",
  alignItems: "flex-start",
};

const messageContentStyles: React.CSSProperties = {
  flex: 1,
  minWidth: 0,
  overflowWrap: "anywhere",
  wordBreak: "break-word",
};

const messageTitleStyles: React.CSSProperties = {
  marginBottom: "4px",
};

const messageDetailsStyles: React.CSSProperties = {
  margin: 0,
};

export const MessageDetailsCard: React.FunctionComponent<MessageDetailsCardProps> = (props) => {
  const { message, index, onCheck } = props;
  const baseId = message.key;

  function check(e: CheckboxChangeEvent) {
    onCheck(message, e.value);
  }

  return (
    <div className={"shadowedCard"} id={`${baseId}-card`} aria-label={`${baseId}-card`} key={index} style={cardStyles}>
      <Checkbox
        checked={message.selected}
        size="large"
        rounded="small"
        style={checkboxStyles}
        id={`${baseId}-checkbox`}
        aria-label={`${baseId}-checkbox`}
        onChange={(e) => check(e)}
        key={`check-${index}`}
      />
      <div style={messageContentStyles}>
        <div id={`${baseId}-title`} aria-label={`${baseId}-title`} style={messageTitleStyles}>
          {message.text}
        </div>
        <p id={`${baseId}-details`} aria-label={`${baseId}-details`} style={messageDetailsStyles}>
          {message.details}
        </p>
      </div>
    </div>
  );
};
